// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yoq8","title":"styles_title__2XwF4"};